import { inject, Injectable } from '@angular/core';
import { Event, IsActiveMatchOptions, NavigationExtras, Router, UrlTree } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';

import { AppNavigationService } from './app-navigation.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class RouterService {
  private router = inject(Router);
  private navigationService = inject(AppNavigationService);

  public readonly events: Subject<Event> = new Subject<Event>();

  public constructor() {
    this.router.events
      .pipe(untilDestroyed(this))
      .subscribe((event) => this.events.next(event));
  }

  public isActive(url: string | UrlTree, exact: boolean): boolean {
    const matchOptions: IsActiveMatchOptions = exact
      ? { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' }
      : { paths: 'subset', queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored' };

    return this.router.isActive(url, matchOptions);
  }

  public getUrl(): string {
    return this.router.url;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return this.navigationService.hasRoute()
      ? Promise.resolve(false)
      : this.router.navigate(commands, extras);
  }

  public navigateByUrl(url: string | UrlTree, extras?: NavigationExtras): Promise<boolean> {
    return this.navigationService.hasRoute()
      ? Promise.resolve(false)
      : this.router.navigateByUrl(url, extras);
  }

  public IsExternalGuarded(url: string): boolean {
    return this.navigationService.IsExternalGuarded(url);
  }
}
